import React from "react";
import { useState } from "react";
import Layout from "../components/Layout";
import PageTitle from "../components/PageTitle";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import {
  listVisaDescription,
  updateVisaDescription,
} from "../redux/actions/visaAction";
import { useEffect } from "react";
import { VISA_UPDATE_RESET } from "../redux/constants/visaConstant";

const EditVisaScreen = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tag = searchParams.get("tag");
  const { uuid } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const listVisaDescriptionState = useSelector(
    (state) => state.listVisaDescription
  );
  const { descriptions } = listVisaDescriptionState;
  const visaDescriptionEdit = useSelector((state) => state.visaDescriptionEdit);
  const { success } = visaDescriptionEdit;

  const [description, setDescription] = useState("");

  const handleEditVisaForm = (e) => {
    e.preventDefault();
    dispatch(updateVisaDescription(description, uuid));
  };

  const handleCkEditorChange = (e, editor) => {
    setDescription(editor.getData());
  };

  useEffect(() => {
    dispatch(listVisaDescription(tag));
    if (success) {
      navigate(`/visa?tag=${tag}`);
      dispatch({ type: VISA_UPDATE_RESET });
    }
  }, [success]);
  return (
    <Layout>
      <PageTitle title="Edit Program, Territorial Competence" />
      <div className="card">
        <div className="card-body">
          <form onSubmit={handleEditVisaForm}>
            <div className="col-12 mb-3">
              <CKEditor
                editor={ClassicEditor}
                class="form-control"
                placeholder="Description of Job"
                style={{ width: "100%" }}
                onChange={(e, editor) => {
                  handleCkEditorChange(e, editor);
                }}
                data={descriptions && descriptions.description}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Edit
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default EditVisaScreen;
